export default __webpack_public_path__ + "partials/footer_upsell.hbs";